module.exports = __webpack_public_path__ + "img/项目审核.924b159c.png";